import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _get from 'lodash/get';
import { PREVIOUS_DIRECTION, NEXT_DIRECTION } from './PaginatedArrow.constants';
import { getDirectionHandler, getDefaultDirectionIcon } from './PaginatedArrow.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import { EVENT_ACTIONS } from '../../../../../analytics/components/Event/Event.constants';
import Icon from '../../../Icon/Icon';
import { PaginationContext } from '../../contexts/pagination';
var defaultProps = {
  children: null,
  icon: ''
};
export default function PaginationArrow(_ref) {
  var direction = _ref.direction,
    children = _ref.children,
    iconProp = _ref.icon;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var onPreviousPage = pagination.onPreviousPage,
    onNextPage = pagination.onNextPage,
    totalPages = pagination.totalPages,
    pageSize = pagination.pageSize,
    getOriginalItems = pagination.getOriginalItems;
  var items = getOriginalItems();
  var hideArrow = totalPages <= 1 || items.length <= pageSize;
  if (hideArrow) {
    return null;
  }
  function handleDirectionClick() {
    var category = _get(event, 'category');
    var action = EVENT_ACTIONS.PAGINATION_ARROW_EVENT_ACTION;
    GoogleAnalytics.event(category, action, {
      label: direction
    });
    return getDirectionHandler(direction, {
      next: onNextPage,
      previous: onPreviousPage
    });
  }
  var icon = iconProp || getDefaultDirectionIcon(direction);
  var defaultButton = /*#__PURE__*/React.createElement(Button, {
    icon: true,
    "aria-label": direction
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: icon
  }));
  var finalButton = children || defaultButton;
  return /*#__PURE__*/React.cloneElement(finalButton, _objectSpread(_objectSpread({}, finalButton.props), {}, {
    onClick: function onClick() {
      return handleDirectionClick()();
    }
  }));
}
PaginationArrow.defaultProps = defaultProps;